import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useCoursesState = createStateHook(
  AppStoreProvider,
  state => state.pages.courses
)
export const useNextCoursesState = () =>
  createNextHook(AppStoreProvider, state => state.pages.courses)
